import { render, staticRenderFns } from "./SumLabelMakerCahaya.vue?vue&type=template&id=40624a84&scoped=true&"
import script from "./SumLabelMakerCahaya.vue?vue&type=script&lang=js&"
export * from "./SumLabelMakerCahaya.vue?vue&type=script&lang=js&"
import style0 from "./SumLabelMakerCahaya.vue?vue&type=style&index=0&id=40624a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40624a84",
  null
  
)

export default component.exports